// Service definitions for the multi-service Premium Calculator.
// Prices are in CHF. ROI hoursPerFeature = estimated monthly hours saved per selected feature.
// pricePerEmployee: monthly cost per employee (0 if service is not per-seat).
// agencyMultiplier: rough benchmark of what a Swiss agency would charge (used for "you save" panel).

export const CALCULATOR_SERVICES = [
  {
    id: 'employee-app',
    icon: 'Users',
    tKey: 'employeeApp',
    monthlyPerEmployee: 65,
    monthlyFixed: 0,
    hasEmployeeSlider: true,
    hoursPerFeature: 3, // hours saved per feature per employee per month
    hourlyRate: 80,
    agencyMultiplier: 2.4,
    basePackage: [
      { id: 'emp-mgmt', tKey: 'empMgmt', price: 1200 },
      { id: 'checkin', tKey: 'checkin', price: 840 },
    ],
    addons: [
      { id: 'dashboard', tKey: 'dashboard', price: 1440, popular: true },
      { id: 'photos', tKey: 'photos', price: 600 },
      { id: 'cars', tKey: 'cars', price: 720 },
      { id: 'vacation', tKey: 'vacation', price: 720 },
      { id: 'reports', tKey: 'reports', price: 1440 },
      { id: 'mobile', tKey: 'mobile', price: 960, popular: true },
    ],
    presets: {
      starter: [],
      business: ['dashboard', 'mobile'],
      enterprise: ['dashboard', 'photos', 'cars', 'vacation', 'reports', 'mobile'],
    },
  },
  {
    id: 'internal-tool',
    icon: 'LayoutDashboard',
    tKey: 'internalTool',
    monthlyPerEmployee: 0,
    monthlyFixed: 79,
    hasEmployeeSlider: false,
    hoursPerFeature: 12,
    hourlyRate: 80,
    agencyMultiplier: 2.3,
    basePackage: [
      { id: 'data-mgmt', tKey: 'dataMgmt', price: 1000 },
      { id: 'user-access', tKey: 'userAccess', price: 700 },
    ],
    addons: [
      { id: 'custom-dashboards', tKey: 'customDashboards', price: 1200, popular: true },
      { id: 'notifications', tKey: 'notifications', price: 500 },
      { id: 'import-export', tKey: 'importExport', price: 600 },
      { id: 'roles', tKey: 'roles', price: 800 },
      { id: 'search-filters', tKey: 'searchFilters', price: 900 },
      { id: 'api-integration', tKey: 'apiIntegration', price: 1500, popular: true },
    ],
    presets: {
      starter: [],
      business: ['custom-dashboards', 'search-filters'],
      enterprise: ['custom-dashboards', 'notifications', 'import-export', 'roles', 'search-filters', 'api-integration'],
    },
  },
  {
    id: 'process-automation',
    icon: 'Zap',
    tKey: 'processAutomation',
    monthlyPerEmployee: 0,
    monthlyFixed: 89,
    hasEmployeeSlider: false,
    hoursPerFeature: 25,
    hourlyRate: 80,
    agencyMultiplier: 2.5,
    basePackage: [
      { id: 'workflow-engine', tKey: 'workflowEngine', price: 1500 },
      { id: 'task-scheduler', tKey: 'taskScheduler', price: 800 },
    ],
    addons: [
      { id: 'email-automation', tKey: 'emailAutomation', price: 700, popular: true },
      { id: 'report-generation', tKey: 'reportGeneration', price: 1000 },
      { id: 'data-sync', tKey: 'dataSync', price: 1500, popular: true },
      { id: 'alerts', tKey: 'alerts', price: 400 },
      { id: 'error-logs', tKey: 'errorLogs', price: 600 },
      { id: 'rules-engine', tKey: 'rulesEngine', price: 1200 },
    ],
    presets: {
      starter: [],
      business: ['email-automation', 'data-sync'],
      enterprise: ['email-automation', 'report-generation', 'data-sync', 'alerts', 'error-logs', 'rules-engine'],
    },
  },
  {
    id: 'web-desktop',
    icon: 'Globe',
    tKey: 'webDesktop',
    monthlyPerEmployee: 0,
    monthlyFixed: 99,
    hasEmployeeSlider: false,
    hoursPerFeature: 8,
    hourlyRate: 80,
    agencyMultiplier: 2.6,
    basePackage: [
      { id: 'frontend-ui', tKey: 'frontendUi', price: 1800 },
      { id: 'backend-api', tKey: 'backendApi', price: 1600 },
    ],
    addons: [
      { id: 'auth-system', tKey: 'authSystem', price: 900, popular: true },
      { id: 'database-design', tKey: 'databaseDesign', price: 800 },
      { id: 'admin-panel', tKey: 'adminPanel', price: 1400, popular: true },
      { id: 'payment-integration', tKey: 'paymentIntegration', price: 1500 },
      { id: 'multi-language', tKey: 'multiLanguage', price: 700 },
      { id: 'desktop-app', tKey: 'desktopApp', price: 2000 },
    ],
    presets: {
      starter: [],
      business: ['auth-system', 'admin-panel'],
      enterprise: ['auth-system', 'database-design', 'admin-panel', 'payment-integration', 'multi-language', 'desktop-app'],
    },
  },
];
